import React from 'react';
import './index.css';
import { Link } from 'react-router-dom';

function PowerBI() {
  return (
    <div>
      <header>
        <nav>
          <ul>
            <li><Link to="/">Home</Link></li>
          </ul>
        </nav>
      </header>

      <section id="powerbi" className="section">
      <div className="container">
        <h2>PowerBI Dashboard</h2>
        <p>2023 Housing Market Data for Pakistan. See <a href="https://www.kaggle.com/datasets/manjitbaishya001/house-prices-2023" style={{ textDecoration: 'underline' }}>Data</a> Here.</p>
        <p>The below images display the Housing Data dashboard. The actual PowerBI dashboard can only be accessed with permissions.</p>
        <div className="powerbi-imgs">
            <img src="power1.png" alt="All Data"/>
            <p>The above dashboard illustrates all the housing market data for houses in Pakistan in 2023.</p>
            <img src="power2.png" alt="City Data"/>
            <p>The above dashboard illustrates the housing market data for houses in Faisalabad in 2023.</p>
            <img src="power3.png" alt="Location Data"/>
            <p>The above dashboard illustrates  the housing market data for houses at 204 Chak Road, Faisalabad in 2023.</p>

        </div>
        </div>

      </section>
    </div>
  );
}

export default PowerBI;
